import { gql } from '@apollo/client'
import { scoreGridFragment } from './fragments/scoreGridFragment'

export const SAVE_SCORE_GRID_MUTATION = gql`
  mutation SaveScoreGrid($meetingId: HashedId!, $grid: ScoreGridInput!) {
    saveScoreGrid(meetingId: $meetingId, grid: $grid) {
      ...ScoreGridFragment
    }
  }

  ${scoreGridFragment}
`
